import classnames from 'classnames'
import Image from '@hashicorp/react-image'
import FlightIcon from '@hashicorp/react-hds/src/components/flight-icon'
import mitigateWidows from '@hashicorp/platform-util/text/mitigate-widows'
import s from './event-title.module.css'

interface EventTitleProps {
	title: string
	tagLine: string
	partnerLogos: {
		url: string
		alt: string
	}[]
	type: 'live' | 'recorded' | 'pending'
}

export default function EventTitle({
	title,
	tagLine,
	partnerLogos,
	type,
}: EventTitleProps) {
	return (
		<div className={s.eventTitle}>
			{partnerLogos?.length > 0 ? (
				<div
					className={classnames(
						s.logoGroup,
						type === 'recorded' && partnerLogos && s.withPartnerLogo
					)}
				>
					<div className={s.partnerLogos}>
						{partnerLogos.map((logo) => {
							return (
								<Image
									key={logo.url}
									className={s.companyLogo}
									alt={logo.alt}
									url={logo.url}
								/>
							)
						})}
					</div>
				</div>
			) : null}

			<div className={s.textContainer}>
				{type === 'recorded' ? (
					<p className={s.eyebrow}>Recorded Webinar</p>
				) : null}

				<h3
					className={s.title}
					dangerouslySetInnerHTML={{ __html: mitigateWidows(title) }}
				/>

				{type === 'live' ? (
					<div className={s.tagLine}>
						<FlightIcon name="calendar" size={24} />
						<span className="g-type-display-6">{tagLine}</span>
					</div>
				) : null}
			</div>
		</div>
	)
}
